import MovieLinks from "../components/movieLinks/MovieLinks";

export default function MovieLinksPage() {
  return <MovieLinks />;
}
